import React, { useState, useEffect, useLayoutEffect, useMemo } from "react";
import { useParams, Route } from "react-router-dom";
import Cookies from "universal-cookie";
import {
  GetEmbedDynamicPageForEdit,
  deleteEmbedPageLogo,
  getRandomInt,
  deleteEmbedFormLogo,
} from "../Helpers/ApiCalles.js";
import { updatePageDetails } from "../Helpers/ExternalFunctions.js";
import queryString from "query-string";
import { useNavigate, useLocation } from "react-router-dom";
import EditEmbedPageBody from "./EditEmbedPageBody/EditEmbedPageBody.js";
import {
  defaultBackgrounds,
  embedColorCode,
} from "components/Reusable/JUMBOform/ExternalJsonsList/JsonLists.js";
import config from "config";
import { getSpecificReactConst } from "components/Reusable/EmbedFormTemplate/Helpers/EmbedApiCalls.js";
import EmbedConfirmMailModal from "components/Reusable/JUMBOform/Modals/EmbedConfirmMailModal.js";
import JUMBOformGlobalModal from "components/Reusable/JUMBOform/Modals/JUMBOformGlobalModal.js";
import ProductTourWrapper from "components/Reusable/ProductTour/ProductTourWrapper.js";
import NotLoginContainer from "components/Reusable/NotLoginContainer/NotLoginContainer.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import Login from "components/Structure/Login/Login.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useUser } from "contexts/userContext/userContext.js";
import Header from "./EditEmbedPageHeader/Header.js";
import SidePanel from "./SidePanel/SidePanel.js";
import { setLocalStorage } from "utils/globalLocalStorage.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import Image from "components/Elements/Image/Image.tsx";

const EditEmbedPageContainer = ({
  pageMode,
  setPageMode,
  loading,
  setLoading,
  demoPageId = null,
  isFirstTime,
  setIsFirstTime,
}) => {
  //Global States
  const navigate = useNavigate();
  const { desktopCondition } = useMediaQueries();
  const { setModal } = useModal();
  const { getTextByKey, getPath, getDirection, getLanguage } = useContent();
  const params = useParams();
  const { getUserData, isLoggedIn } = useUser();
  const userData = getUserData();
  //Page States
  const [FullDetailsEmbedPage, setFullDetailsEmbedPage] = useState(null);
  const [userNamePage, setUserNamePage] = useState(null);
  const [logoImage, setLogoImage] = useState(null);
  const [titlePage, setTitlePage] = useState("");
  const [textPage, setTextPage] = useState("");
  const [isValidPage, setIsValidPage] = useState(true);
  const [loadImageBackground, setLoadImageBackground] = useState(false);
  const [singleForm, setSingleForm] = useState(false);
  const [loadingCarousel, setLoadingCarousel] = useState(false);
  //Mode page Settings:
  const [viewType, setViewType] = useState("desktop");
  //Forms Settings:
  const [EmbedPageFormList, setEmbedPageFormList] = useState([]);
  const [userFormsList, setUserFormsList] = useState([]);
  const [oldEmbedPageFormList, setOldEmbedPageFormList] = useState([]);
  const [selectedForms, setSelectedForms] = useState([]); //only Id's
  const [countActiveForms, setCountActiveForms] = useState([]);
  //DESIGN SETTINGS:
  const [pageLanguage, setPageLanguage] = useState(getLanguage());
  const [brandingColor, setBrandingColor] = useState(embedColorCode);
  const [diractionPage, setDiractionPage] = useState(getDirection());
  const [singleOrRotate, setSingleOrRotate] = useState("Single"); //EmbedPageBackgroundDisplay
  const [backgroundImagesList, setBackgroundImagesList] = useState([]);
  const [backgroundImageListURLS, setBackgroundImageListURLS] = useState([]); //only Url's
  const [displayFormDetialsDB, setDisplayFormDetialsDB] = useState(false);
  const [displayFormDetails, setDisplayFormDetails] = useState(
    viewType !== "desktop" ? true : displayFormDetialsDB
  );
  const [displaySidePanel, setDisplaySidePanel] = useState(true);
  useEffect(() => {
    //get the size of the screen
    const widthScreen = window.innerWidth;
    if (viewType !== "desktop" || widthScreen < desktopCondition) {
      setDisplayFormDetails(true);
    } else {
      setDisplayFormDetails(displayFormDetialsDB);
    }
  }, [viewType, displayFormDetialsDB, desktopCondition]);

  //Social settings:
  const [websiteLink, setWebsiteLink] = useState("");
  const [youtubeLink, setYoutubeLink] = useState("");
  const [facebookLink, setFacebookLink] = useState("");
  const [instagramLink, setInstagramLink] = useState("");
  const [twitterLink, setTwitterLink] = useState("");
  const [vimeoLink, setVimeoLink] = useState("");
  const [linkedinLink, setLinkedinLink] = useState("");
  const [whatsappLink, setWhatsappLink] = useState("");
  const [phoneLink, setPhoneLink] = useState("");
  const [emailLink, setEmailLink] = useState("");
  const [backButtonText, setBackButtonText] = useState(
    getTextByKey("back-home")
  );
  const [checkOrderStatusText, setCheckOrderStatusText] = useState(
    getTextByKey("check-status-button-embedpage")
  );
  useEffect(() => {
    getSpecificReactConst({
      key: "back-home",
      lang: pageLanguage,
      setState: setBackButtonText,
    });
    getSpecificReactConst({
      key: "check-status-button-embedpage",
      lang: pageLanguage,
      setState: setCheckOrderStatusText,
    });
  }, [pageLanguage]);

  //Update title by click outside the input
  const socialLinks = [
    {
      title: "Email",
      name: "Email",
      state: emailLink,
      setState: setEmailLink,
    },
    {
      title: "Phone",
      name: "Phone",
      state: phoneLink,
      setState: setPhoneLink,
    },
    {
      title: "Website",
      name: "Website",
      state: websiteLink,
      setState: setWebsiteLink,
    },
    {
      title: "Facebook",
      name: "Facebook",
      state: facebookLink,
      setState: setFacebookLink,
    },
    {
      title: "Whatsapp",
      name: "Whatsapp",
      state: whatsappLink,
      setState: setWhatsappLink,
    },
    {
      title: "Linkedin",
      name: "Linkedin",
      state: linkedinLink,
      setState: setLinkedinLink,
    },
    {
      title: "YouTube",
      name: "YouTube",
      state: youtubeLink,
      setState: setYoutubeLink,
    },
    {
      title: "Instagram",
      name: "Instagram",
      state: instagramLink,
      setState: setInstagramLink,
    },
    {
      title: "Twitter",
      name: "Twitter",
      state: twitterLink,
      setState: setTwitterLink,
    },
    {
      title: "Vimeo",
      name: "Vimeo",
      state: vimeoLink,
      setState: setVimeoLink,
    },
  ];
  //SEO
  const [personalPageUrl, setPersonalPageUrl] = useState(""); //EmbedPageUserName
  const [browserTitle, setBrowserTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [bodyScripts, setBodyScripts] = useState("");
  const [headScripts, setHeadScripts] = useState("");
  const [searchEngines, setSearchEngines] = useState(true);
  //background settings:
  const [randomBackground, setRandomBackground] = useState(null);
  const [isDefaultBackgrounds, setIsDefaultBackgrounds] = useState(false);
  const [randomUrlImage, setRandomUrlImage] = useState("");
  ////Side Panel:
  const [isOpen, setIsOpen] = useState(false);
  const [typeOfSettings, setTypeOfSettings] = useState(null);
  const [showOrderTracker, setShowOrderTracker] = useState(true);
  //Forms details
  const [formImage, setFormImage] = useState(null);
  const [formImagesLoaded, setFormImagesLoaded] = useState(0);
  const [isFormImagesLoaded, setIsFormImagesLoaded] = useState(false);
  const [formImages, setFormImages] = useState([]);
  //Footer page:
  const [linkFooters, setLinkFooters] = useState([
    {
      FooterLinkTitle: getTextByKey("about-footer"),
      FooterLinkUrl: config.baseurl + getPath() + "jumbo-forms",
    },
    {
      FooterLinkTitle: getTextByKey("support-footer"),
      FooterLinkUrl: config.baseurl + getPath() + "support/jumbo-embed",
    },
    {
      FooterLinkTitle: getTextByKey("terms-footer"),
      FooterLinkUrl: config.baseurl + getPath() + "terms",
    },
  ]);

  //if user not loggin - open login modal and if login - return back the page if not - display message (not relevant for anonymous from marketing page)
  const cookies = new Cookies();
  const isTokenExist = cookies.get(config.api.jumbomailApiAuthCookie);
  useLayoutEffect(() => {
    if (!isTokenExist) {
      setModal({
        modal: Login,
        modalSize: "full-modal",
      });
    }
  }, [isTokenExist]);

  //Check if anonymouse parameters exist in the url, if not, add mode param to page url
  useEffect(() => {
    if (pageMode) {
      navigate("?mode=" + pageMode);
    }
  }, [pageMode]);

  //check if mode param exist in the url and set the mode (if anonymouse set preview);
  const location = useLocation();
  useMemo(() => {
    if (location.search.includes("mode")) {
      const mode = queryString.parse(location.search).mode;
      setPageMode(mode);
    }
  }, []);

  //open the side panel
  const openSidePanel = (type) => {
    if (typeOfSettings === type) {
      setIsOpen(false);
      setTimeout(() => {
        setTypeOfSettings(null);
      }, 500);
    } else {
      setTypeOfSettings(type);
      setIsOpen(true);
    }
  };

  //Forms:
  useEffect(() => {
    if (oldEmbedPageFormList.length !== EmbedPageFormList.length) {
      setLoadingCarousel(true);
      setOldEmbedPageFormList(EmbedPageFormList);
      setTimeout(() => {
        setLoadingCarousel(false);
      }, 1000);
    }
    //count the number of active forms in oldEmbedPageFormList
    let activeForms = 0;
    if (oldEmbedPageFormList) {
      if (oldEmbedPageFormList.length === 1) {
        activeForms = 1;
      }
    }
    if (oldEmbedPageFormList.length > 1) {
      //count the number of active forms in oldEmbedPageFormList
      oldEmbedPageFormList.forEach((form) => {
        if (form.isActive) {
          activeForms++;
        }
      });
    }
    setCountActiveForms(activeForms);
  }, [EmbedPageFormList, oldEmbedPageFormList]);

  useEffect(() => {
    if (selectedForms && oldEmbedPageFormList) {
      if (selectedForms.length !== oldEmbedPageFormList.length) {
      }
    }
  }, [selectedForms, oldEmbedPageFormList]);

  //Get full details
  useEffect(() => {
    if (
      params &&
      params.EmbedPageUserName &&
      params.EmbedPageUserName !== undefined &&
      userData &&
      userData.UserId !== undefined
    ) {
      GetEmbedDynamicPageForEdit({
        isAnonymouse: false,
        setLoading: setLoading,
        setFullDetailsEmbedPage: setFullDetailsEmbedPage,
        userName: params.EmbedPageUserName,
        setIsValidPage,
        demoPageId: 0,
      });

      setUserNamePage(params.EmbedPageUserName);
    }
  }, [userData]);

  const [tempImage, setTempImage] = useState({});

  //Set the page details to the states
  useEffect(() => {
    updatePageDetails({
      FullDetailsEmbedPage,
      setTextPage,
      setTitlePage,
      setPersonalPageUrl,
      setDiractionPage,
      directionUrl: getDirection(),
      setSingleOrRotate,
      setSelectedForms,
      setEmbedPageFormList,
      setOldEmbedPageFormList,
      setBackgroundImagesList,
      setLogoImage,
      socialLinks,
      setBodyScripts,
      setHeadScripts,
      setMetaDescription,
      setBrowserTitle,
      setShowOrderTracker,
      setBrandingColor,
      setFormImages,
      setSingleForm,
      setLinkFooters,
      setUserFormsList,
      setPageLanguage,
      setSearchEngines,
      demoPageId,
      tempImage,
      setTempImage,
      setDisplayFormDetialsDB,
      setDisplaySidePanel,
    });
  }, [FullDetailsEmbedPage]);

  //Background images:
  const newChangeBackgroundImage = ({ random }) => {
    if (random) {
      const randomNum = getRandomInt(backgroundImageListURLS.length);
      setRandomBackground(backgroundImageListURLS[randomNum]);
    } else {
      setRandomBackground(backgroundImageListURLS[0]);
    }
  };

  useEffect(() => {
    if (
      FullDetailsEmbedPage &&
      FullDetailsEmbedPage.EmbedDynamicPage &&
      backgroundImageListURLS.length > 0
    ) {
      newChangeBackgroundImage({
        random: singleOrRotate === "Random",
      });
    }
  }, [FullDetailsEmbedPage, backgroundImageListURLS, singleOrRotate]);

  useEffect(() => {
    if (FullDetailsEmbedPage) {
      if (backgroundImagesList && backgroundImagesList.length > 0) {
        const urlImagesList = backgroundImagesList.map((item) => item.ImageSrc);
        setBackgroundImageListURLS(urlImagesList);
        setIsDefaultBackgrounds(false);
      } else {
        setIsDefaultBackgrounds(true);
        setBackgroundImageListURLS(defaultBackgrounds);
      }
    }
  }, [backgroundImagesList]);

  useEffect(() => {
    if (randomBackground) {
      setRandomUrlImage(randomBackground);
      setLoadImageBackground(true);
    }
  }, [randomBackground]);
  //End background images

  //Remove the embed page logo
  const removeImageApi = () => {
    if (
      FullDetailsEmbedPage &&
      FullDetailsEmbedPage.EmbedDynamicPage &&
      FullDetailsEmbedPage.EmbedDynamicPageLogo
    ) {
      deleteEmbedPageLogo({
        embedPageId: FullDetailsEmbedPage.EmbedDynamicPage.EmbedPageId,
        setLogoImage,
      });
    }
  };

  //remove the form image
  const removeFormImageApi = (formId) => {
    deleteEmbedFormLogo({
      formImage: formImage,
      setFormImage: setFormImage,
      formId: formId,
      setFullDetailsEmbedPage: setFullDetailsEmbedPage,
      FullDetailsEmbedPage: FullDetailsEmbedPage,
    });
  };

  //Load the form list images
  const loadFormImages = () => {
    return formImages.map((item, i) => (
      <Image
        key={i}
        className="loading-embed-background"
        onLoad={() => setFormImagesLoaded((prev) => prev + 1)}
        src={item}
        alt=""
        title=""
      />
    ));
  };

  useEffect(() => {
    if (!isValidPage) {
      setLoadImageBackground(true);
      setIsFormImagesLoaded(true);
      setLoading(false);
    }
  }, [isValidPage]);

  useEffect(() => {
    if (FullDetailsEmbedPage) {
      if (formImagesLoaded >= formImages.length) {
        setIsFormImagesLoaded(true);
      }

      if (formImages.length === 0) {
        setIsFormImagesLoaded(true);
      }
    }
    if (formImages.length > 0) {
      setFormImagesLoaded(formImages.length);
    }
  }, [formImagesLoaded, formImages]);

  //Set the accecability icon direction
  const accessabilityIcon = document.getElementById("userwayAccessibilityIcon");
  useEffect(() => {
    if (accessabilityIcon && accessabilityIcon !== undefined) {
      accessabilityIcon.style.bottom = "60px";
      if (getDirection() !== "rtl") {
        accessabilityIcon.style.left = "unset";
        accessabilityIcon.style.right = "50px";
      } else {
        accessabilityIcon.style.left = "50px";
        accessabilityIcon.style.right = "unset";
      }
    }
  }, [getDirection(), accessabilityIcon]);

  useEffect(() => {
    if (
      isLoggedIn() &&
      loadImageBackground &&
      isFormImagesLoaded &&
      isValidPage
    ) {
      setTimeout(() => {
        if (!userData.IsConfirm) {
          setModal(() => <EmbedConfirmMailModal />);
        }
      }, 1000);
    }
  }, [isLoggedIn(), loadImageBackground, isFormImagesLoaded, isValidPage]);

  useMemo(() => {
    if (isFirstTime && FullDetailsEmbedPage && pageMode === "preview") {
      setModal(() => (
        <JUMBOformGlobalModal
          title="welcome-to-personal-page"
          text="welcome-embedpage-text"
        />
      ));
      setLocalStorage(`welcome-embedpage-${params.EmbedPageUserName}`, "true");
      setIsFirstTime(false);
    }
  }, [isFirstTime, FullDetailsEmbedPage, pageMode]);

  if (!isValidPage) {
    window.location.href =
      config.baseurl + "" + getPath() + "user/jumbo-forms/form-management";
    return null; // Return null to prevent rendering this component when redirecting
  }

  return (
    <>
      {isValidPage && randomBackground && isDefaultBackgrounds ? (
        <Image
          onLoad={() => setLoadImageBackground(true)}
          className="loading-embed-background"
          name={randomUrlImage}
          ext="webp"
          alt=""
        ></Image>
      ) : null}
      {isLoggedIn() ? (
        <div
          className={`personal-branded-page ${
            pageMode === "preview" ? viewType : ""
          } ${pageMode === "preview" ? "preview-mode" : ""}`}
        >
          {loadImageBackground && isFormImagesLoaded ? (
            <>
              {FullDetailsEmbedPage && isValidPage && pageMode ? (
                <>
                  <Header
                    backgroundImageListURLS={backgroundImageListURLS}
                    titlePage={titlePage}
                    pageMode={pageMode}
                    setPageMode={setPageMode}
                    selectedForms={selectedForms}
                    dynamicFormsList={
                      FullDetailsEmbedPage.EmbedDynamicForms
                        ? FullDetailsEmbedPage.EmbedDynamicForms
                        : []
                    }
                    FullDetailsEmbedPage={FullDetailsEmbedPage}
                    userNamePage={userNamePage}
                    setViewType={setViewType}
                    viewType={viewType}
                  />
                  <div className={`personal-branding-container`}>
                    <>
                      {pageMode === "edit" && (
                        <>
                          <ProductTourWrapper
                            isPageReady={userData.IsConfirm}
                          />
                          <SidePanel
                            FullDetailsEmbedPage={FullDetailsEmbedPage}
                            isDefaultBackgrounds={isDefaultBackgrounds}
                            isOpen={isOpen}
                            setIsOpen={setIsOpen}
                            openSidePanel={openSidePanel}
                            typeOfSettings={typeOfSettings}
                            setTypeOfSettings={setTypeOfSettings}
                            setBackgroundImagesList={setBackgroundImagesList} //Design
                            backgroundImagesList={backgroundImagesList}
                            setSingleOrRotate={setSingleOrRotate}
                            singleOrRotate={singleOrRotate}
                            setBrandingColor={setBrandingColor}
                            brandingColor={brandingColor}
                            pageLanguage={pageLanguage}
                            setPageLanguage={setPageLanguage}
                            diractionPage={diractionPage}
                            setDiractionPage={setDiractionPage}
                            displayFormDetialsDB={displayFormDetialsDB}
                            setDisplayFormDetialsDB={setDisplayFormDetialsDB}
                            displaySidePanel={displaySidePanel}
                            setDisplaySidePanel={setDisplaySidePanel}
                            EmbedPageFormList={EmbedPageFormList} //Forms
                            setEmbedPageFormList={setEmbedPageFormList}
                            selectedForms={selectedForms}
                            setSelectedForms={setSelectedForms}
                            userFormsList={userFormsList}
                            showOrderTracker={showOrderTracker}
                            setShowOrderTracker={setShowOrderTracker}
                            socialLinks={socialLinks} //Social
                            personalPageUrl={personalPageUrl}
                            setBrowserTitle={setBrowserTitle} //SEO
                            browserTitle={browserTitle}
                            headScripts={headScripts}
                            setHeadScripts={setHeadScripts}
                            bodyScripts={bodyScripts}
                            setBodyScripts={setBodyScripts}
                            setMetaDescription={setMetaDescription}
                            metaDescription={metaDescription}
                            searchEngines={searchEngines}
                            setSearchEngines={setSearchEngines}
                          />
                        </>
                      )}
                      <EditEmbedPageBody
                        checkOrderStatusText={checkOrderStatusText}
                        backButtonText={backButtonText}
                        logoImage={logoImage}
                        setLogoImage={setLogoImage}
                        pageMode={pageMode}
                        setTextPage={setTextPage}
                        textPage={textPage}
                        setTitlePage={setTitlePage}
                        titlePage={titlePage}
                        diractionPage={diractionPage}
                        FullDetailsEmbedPage={FullDetailsEmbedPage}
                        EmbedPageFormList={EmbedPageFormList}
                        setEmbedPageFormList={setEmbedPageFormList}
                        removeImageApi={removeImageApi}
                        removeFormImageApi={removeFormImageApi}
                        socialLinks={socialLinks}
                        formImage={formImage}
                        setFormImage={setFormImage}
                        randomBackground={randomBackground}
                        brandingColor={brandingColor}
                        singleForm={singleForm}
                        randomUrlImage={randomUrlImage}
                        oldEmbedPageFormList={oldEmbedPageFormList}
                        setOldEmbedPageFormList={setOldEmbedPageFormList}
                        loadingCarousel={loadingCarousel}
                        linkFooters={linkFooters}
                        setLinkFooters={setLinkFooters}
                        viewType={viewType}
                        showOrderTracker={showOrderTracker}
                        userFormsList={userFormsList}
                        setUserFormsList={setUserFormsList}
                        pageLanguage={pageLanguage}
                        isOpen={isOpen}
                        countActiveForms={countActiveForms}
                        displayFormDetails={displayFormDetails}
                        setDisplayFormDetails={setDisplayFormDetails}
                        displaySidePanel={displaySidePanel}
                      />
                    </>
                  </div>
                </>
              ) : (
                !isValidPage && <div className="empty-personal-page"></div>
              )}
            </>
          ) : (
            <div className="loading-personal">
              <Image
                className="loader-animation-gif"
                name="preloader"
                ext="gif"
                alt=""
                title=""
              />
            </div>
          )}
        </div>
      ) : (
        <NotLoginContainer
          TitleKey={"not-logged-in-title"}
          TextKey={"not-logged-in-text"}
        />
      )}
    </>
  );
};

export default EditEmbedPageContainer;
